module.exports = __webpack_public_path__ + "img/image23.11c23296.png";